export function getRandomArray({ length, min, max }: { length: number, min: number, max: number }) {   const array = [];
   while (array.length < length) {
     const randomNum = Math.floor(Math.random() * (max - min + 1)) + min
     if (array.indexOf(randomNum) === -1) {
       array.push(randomNum);
     }
   }
   return array;
 }